<ng-template #modalContent>
    <div class="d-flex flex-row justify-content-between align-items-start">
        <h2 matDialogTitle>
            Are you sure?
        </h2>
        <button type="button" mat-icon-button class="icon-button-small" (click)="closeDialog()">
            <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <p>Invalidating Walt credentials will remove the credential from the database<br>and any signed tokens associated with it.</p>
        <p>You should only do this if you are certain the walt is having issues<br>authenticating their current token.</p>
        <p>This action cannot be undone.</p>
        <p>If you'd like to continue, enter the Walt ID below (case sensitive):</p>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Walt ID</mat-label>
            <input
                matInput
                [(ngModel)]="enteredWaltId"
                [disabled]="isSubmitting()"
            />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <div class="d-flex flex-row justify-content-between gap-3 w-100">
            <button
                mat-button
                (click)="closeDialog()"
                [disabled]="isSubmitting()"
            >Cancel</button>
            <button
                mat-raised-button
                (click)="dialogSubmit()"
                color="primary"
                [disabled]="isSubmitting() || enteredWaltId !== waltId()"
            >
                <div class="d-flex flex-row justify-content-center align-items-center gap-2">
                    <span>Yes</span>
                    <mat-spinner *ngIf="isSubmitting()" diameter="20"/>
                </div>
            </button>
        </div>
    </mat-dialog-actions>
</ng-template>
